import Controller from '@philips-emr/tws-core/lib/client';

import { FragmentNames } from '../../codegen';
import BaseController from '../BaseController';

import './health-declaration.scss';

@Controller({ fragment: FragmentNames.HEALTH_DECLARATION_CANCELATION })
export default class HealthDeclarationCancelationController  extends BaseController{

}
